import * as React from 'react';

import type { DownloadLinks } from '@/shared/modules/download/types';
import { mergeQueryParams } from '@/shared/modules/download/utils/merge-query-params';
import { getStorageItem } from '@/shared/modules/local-storage';
import { UNIQUE_DOWNLOADS_KEY } from '@/shared/modules/local-storage/constants';
import { isEmpty } from '@/shared/utils/is-empty';

import { useGetFullInstallerUrl } from './use-get-full-installer-url';
import { useGetQueryParams } from './use-get-query-params';
import { useSelectDownloadUrl } from './use-select-download-url';

export const useGetDownloadLink = (links: DownloadLinks) => {
  const url = useSelectDownloadUrl(links);
  return useBuildPlariumPlayDownloadUrl(url);
};

function isUniqueDownload() {
  const data = getStorageItem(UNIQUE_DOWNLOADS_KEY, []);
  const downloadedBefore = data.find((i: string) => i === window.location.href);
  if (downloadedBefore) {
    return false;
  }

  return true;
}

function getUniquePartForPlariumPlayDownloadUrl(displayConcatSymbol: boolean) {
  const uniquePart = displayConcatSymbol ? '&uniqueAd=true' : 'uniqueAd=true';
  return isUniqueDownload() ? uniquePart : '';
}

function useBuildPlariumPlayDownloadUrl(url: string, queryOverrideParams?: {}) {
  // Because of hydration, we have to render undefined link first
  // So when component is mounted it will detect change!
  const [downloadLink, setDownloadLink] = React.useState<string | undefined>();

  const fullHttpsUrl = useGetFullInstallerUrl(url);
  const queryParams = useGetQueryParams(queryOverrideParams);
  const uniquePart = getUniquePartForPlariumPlayDownloadUrl(!isEmpty(queryParams));
  const urlWithMergedQueryParams = mergeQueryParams(fullHttpsUrl, queryParams);

  React.useEffect(() => {
    setDownloadLink(`${urlWithMergedQueryParams}${uniquePart}`);
  }, [urlWithMergedQueryParams, uniquePart]);

  return downloadLink;
}
